import React from "react";
import "./promo.scss";
import penawaran from "../../Media/FlashSale.webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";

const Penawaran = () => {
  const Cherrywa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281188083575&text=Halo%20Thobie,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Serpong%20(Flash%20Sale)%20https://marketing-gadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div id="flashsale" className="promosumbog">
      <div className="promo-sumbog">
        <div className="gambarpromo">
          <img src={penawaran} alt={penawaran} />
        </div>
        <div className="ket-promo">
          <div className="judul">
            <h1>Summarecon Serpong</h1>
            <h2>Flash Sale Discount Up To 30%</h2>
          </div>
          <div className="promolist">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Cluster Pascal</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Cluster Martinez</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Cluster Emerald Cove
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Cluster Agnesi</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Cluster Heron </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Cluster Strozzi</span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Cluster Leonora</span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Cluster Carson</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Ruko Melody</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Ruko Carson</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Ruko Edison</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Ruko Downtown Drive{" "}
              </span>
            </div>
          </div>
          <button className="buttonpenawaran" onClick={Cherrywa}>
            Learn More
          </button>
          <p className="promo-disclaimer">
            Informasi properti harga, spesifikasi, dan ketersediaan unit dapat
            berubah sewaktu-waktu, silahkan hubungi kamu untuk informasi terbaru
          </p>
        </div>
      </div>
    </div>
  );
};

export default Penawaran;
